<div class="main-container">
  <img src="assets/droplet2.png" id="droplet-1" alt="picatura de apa" class="d-none d-md-block art-element"/>
  <img src="assets/droplet3.png" id="droplet-2" alt="picatura de apa" class="art-element"/>
  <img src="assets/droplet5.png" id="droplet-3" alt="picatura de apa" class="art-element"/>
  <img src="assets/x-pink.png" id="pink-x" alt="un x roz grafic" class="art-element"/>
  <img src="assets/o-blue.png" id="blue-o" alt="un o albastru grafic" class="art-element"/>
  <img src="assets/x-blue.png" id="blue-x" alt="un x albastru grafic" class="art-element"/>
  <img src="assets/o-yellow.png" id="yellow-o" alt="un o galben grafic" class="art-element"/>
  <app-main-header></app-main-header>
  <div class="content-container" #contentContainer>
    <div class="body-wrapper">
      <router-outlet></router-outlet>
      <app-main-footer></app-main-footer>
      <app-gdpr-alert [opened]="shouldShowGdprNotification"></app-gdpr-alert>
    </div>
  </div>
</div>
